<template>
  <div class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <!-- ✅ Dashboard : visible uniquement pour l'admin et SuperAdmin -->
      <li v-if="canSeeAdminItems" class="nav-item">
        <sidenav-collapse url="/dashboard" :collapse="false" collapseRef="dashboard" :navText="$t('sidebar.dashboard')">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- ✅ Employees Dropdown : visible pour l'admin, SuperAdmin et l'employé -->
      <li v-if="canSeeEmployeeItems || canSeeAdminItems" class="nav-item" :class="{ open: isEmployeesOpen }">
        <a href="#" class="nav-link text-white d-flex align-items-center justify-content-between" @click.prevent="toggleEmployees">
          <div>
            <i class="material-icons-round opacity-10 fs-5 me-2">groups</i>
            <span class="nav-link-text">{{ $t("sidebar.employees") }}</span>
          </div>
          <i class="material-icons fs-6">
            {{ isEmployeesOpen ? 'expand_less' : 'expand_more' }}
          </i>
        </a>

        <ul v-show="isEmployeesOpen" class="nav ms-4 ps-2">
          <!-- Employee List : masqué pour l'employé, visible pour admin et SuperAdmin -->
          <li v-if="canSeeAdminItems" class="nav-item">
            <router-link to="/employees" class="nav-link text-white">
              <i class="material-icons-round me-2 fs-6">list</i>
              {{ $t("sidebar.employeeList") }}
            </router-link>
          </li>

          <!-- Leaves -->
          <li class="nav-item">
            <router-link to="/employee/leaves" class="nav-link text-white">
              <i class="material-icons-round me-2 fs-6">event</i>
              {{ $t("sidebar.leaves") }}
            </router-link>
          </li>
          

          <!-- Loans -->
          <li class="nav-item">
            <router-link to="/employee/loans" class="nav-link text-white">
              <i class="material-icons-round me-2 fs-6">payments</i>
              {{ $t("sidebar.loans") }}
            </router-link>
          </li>

          <!-- Salary Advances -->
          <li class="nav-item">
            <router-link :to="getRouteByRole('salary')" class="nav-link text-white">
              <i class="material-icons-round me-2 fs-6">attach_money</i>
              {{ $t("sidebar.salaryAdvances") }}
            </router-link>
          </li>

          <!-- Certificate Requests -->
          <li class="nav-item">
            <router-link :to="getRouteByRole('certificate')" class="nav-link text-white">
              <i class="material-icons-round me-2 fs-6">description</i>
              {{ $t("sidebar.certificateRequests") }}
            </router-link>
          </li>

   <li v-if="canSeeEmployeeItems" class="nav-item">
  <router-link to="/employee/bank-details-user" class="nav-link text-white">
    <i class="material-icons-round me-2 fs-6">account_balance</i>
    {{ $t("sidebar.bankDetails") }}

  </router-link>
</li>
<li v-if="canSeeEmployeeItems" class="nav-item">
  <router-link to="/employee/professional-info" class="nav-link text-white">
    <i class="material-icons-round me-2 fs-6">badge</i>
    {{ $t("sidebar.professionalInfo") }}


  </router-link>
</li>

<li v-if="canSeeEmployeeItems" class="nav-item">
 <router-link to="/employee/my-documents" class="nav-link text-white">
  <i class="material-icons-round me-2 fs-6">folder</i>
  {{ $t("sidebar.myDocuments") }}

</router-link>


</li>


<!-- My Bonus -->
<li v-if="canSeeEmployeeItems" class="nav-item">
  <router-link to="/employee/my-bonus" class="nav-link text-white">
    <i class="material-icons-round me-2 fs-6">card_giftcard</i>
    {{ $t("sidebar.myBonus") }}

  </router-link>
</li>


          <!-- Authorization -->
          <li class="nav-item">
            <router-link class="nav-link text-white" :to="getRouteByRole('authorization')">
  <i class="material-icons-round me-2 fs-6">schedule</i>
  {{ $t("sidebar.authorization") }}
</router-link>

          </li>

          <!-- Attendance -->
          <li class="nav-item">
            <router-link to="/employee/attendance" class="nav-link text-white">
              <i class="material-icons-round me-2 fs-6">event_available</i>
              {{ $t("sidebar.attendance") }}
            </router-link>
          </li>

          <!-- KPI -->
          <li v-if="canSeeAdminItems" class="nav-item">
            <router-link to="/reference/bonus" class="nav-link text-white">
              <i class="material-icons-round me-2 fs-6">card_giftcard</i>
              {{ $t("sidebar.kpi") }}
            </router-link>
          </li>
        </ul>
      </li>

      <!-- ✅ Global KPI : visible pour l'admin et SuperAdmin -->
      <li v-if="canSeeAdminOnlyItems" class="nav-item">
        <sidenav-collapse url="/bonus-list" :collapse="false" collapseRef="bonuses" :navText="$t('sidebar.globalKpi')">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">card_giftcard</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- ✅ Office Expenses : visible pour l'admin et SuperAdmin -->
      <li v-if="canSeeAdminOnlyItems" class="nav-item">
        <router-link to="/office-expenses" class="nav-link text-white">
          <i class="material-icons-round opacity-10 fs-5 me-2">payments</i>
          <span class="nav-link-text">{{ $t("sidebar.officeExpenses") }}</span>
        </router-link>
      </li>

      <!-- ✅ Training Calendar : visible pour admin et employee -->
      <li class="nav-item">
        <router-link to="/training-calendar" class="nav-link text-white">
          <i class="material-icons-round opacity-10 fs-5 me-2">calendar_month</i>
          <span class="nav-link-text">{{ $t("sidebar.trainingCalendar") }}</span>
        </router-link>
      </li>

      <!-- ✅ Contract : visible pour l'admin et SuperAdmin -->
      <li v-if="canSeeAdminOnlyItems" class="nav-item">
        <sidenav-collapse url="/contracts" :collapse="false" collapseRef="contracts" :navText="$t('sidebar.contract')">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">assignment</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- ✅ Reference Data : visible pour l'admin et SuperAdmin -->
      <li v-if="canSeeAdminOnlyItems" class="nav-item" :class="{ open: isReferenceOpen }">
        <a href="#" class="nav-link text-white d-flex align-items-center justify-content-between" @click.prevent="toggleReference">
          <div>
            <i class="material-icons-round opacity-10 fs-5 me-2">menu_book</i>
            <span class="nav-link-text">{{ $t("sidebar.referenceData") }}</span>
          </div>
          <i class="material-icons fs-6">
            {{ isReferenceOpen ? 'expand_less' : 'expand_more' }}
          </i>
        </a>

        <ul v-show="isReferenceOpen" class="nav ms-4 ps-2">
          <li class="nav-item" v-for="link in referenceLinks" :key="link.to">
            <router-link :to="link.to" class="nav-link text-white">
              <i class="material-icons-round me-2 fs-6">{{ link.icon }}</i>
              {{ $t(link.text) }}
            </router-link>
          </li>
        </ul>
      </li>

      <!-- ✅ Parc : visible pour SuperAdmin uniquement -->
      <li v-if="canSeeSuperAdminOnlyItems" class="nav-item">
        <sidenav-collapse url="/parc" :collapse="false" collapseRef="parc" :navText="$t('sidebar.parc')">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">directions_car</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- ✅ Material : visible pour SuperAdmin et Material Manager -->
      <li v-if="isSuperAdmin || isMaterialManager" class="nav-item">
        <sidenav-collapse url="/material" :collapse="false" collapseRef="material" :navText="$t('sidebar.material')">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">layers</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- ✅ Account Pages : masqué pour les 2 (admin et employee) -->
      <li v-if="false" class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white" :class="$store.state.isRTL ? 'me-4' : 'ms-2'">
          {{ $t("sidebar.accountPages") }}
        </h6>
      </li>

      <li v-if="false" class="nav-item">
        <sidenav-collapse url="/profile" :collapse="false" collapseRef="profile" :navText="$t('sidebar.profile')">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">person</i>
          </template>
        </sidenav-collapse>
      </li>

      <li v-if="false" class="nav-item">
        <sidenav-collapse url="/sign-in" :collapse="false" collapseRef="sign-in" :navText="$t('sidebar.signIn')">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">login</i>
          </template>
        </sidenav-collapse>
      </li>

      <li v-if="false" class="nav-item">
        <sidenav-collapse url="/sign-up" :collapse="false" collapseRef="sign-up" :navText="$t('sidebar.signUp')">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">assignment</i>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: "SidenavList",
  components: { SidenavCollapse },
  data() {
    return {
      isReferenceOpen: false,
      isEmployeesOpen: false,
      referenceLinks: [
        { to: "/reference/projects", icon: "apartment", text: "sidebar.projects" },
        { to: "/reference/positions", icon: "work", text: "sidebar.positions" },
        { to: "/reference/banks", icon: "account_balance", text: "sidebar.banks" },
        { to: "/reference/contract-types", icon: "gavel", text: "sidebar.contractTypes" },
        { to: "/reference/companies", icon: "business", text: "sidebar.companies" },
        { to: "/reference/budget-category", icon: "category", text: "sidebar.budgetCategory" },
        { to: "/reference/budget-sub-category", icon: "subtitles", text: "sidebar.budgetSubCategory" },
        { to: "/reference/document-type", icon: "description", text: "sidebar.documentType" },
        { to: "/reference/certificate-types", icon: "workspace_premium", text: "sidebar.certificateTypes" },
        { to: "/reference/expense-categories", icon: "category", text: "sidebar.expenseCategories" },
      ],
    };
  },
  computed: {
    isAdmin() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return user.roles && user.roles.includes("admin");
    },
    isEmployee() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return user.roles && user.roles.includes("employee");
    },
    isSuperAdmin() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return user.roles && user.roles.includes("SuperAdmin");
    },
    isMaterialManager() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return user.roles && user.roles.includes("Material Manager");
    },
    canSeeAdminItems() {
      return this.isAdmin || this.isSuperAdmin || this.isMaterialManager;
    },
    canSeeAdminOnlyItems() {
      return this.isAdmin || this.isSuperAdmin;
    },
    canSeeSuperAdminOnlyItems() {
      return this.isSuperAdmin;
    },
    canSeeEmployeeItems() {
      return this.isEmployee || this.isMaterialManager;
    }
  },
  methods: {
    
    toggleReference() {
      this.isReferenceOpen = !this.isReferenceOpen;
    },
    toggleEmployees() {
      this.isEmployeesOpen = !this.isEmployeesOpen;
    },
    getRouteByRole(moduleName) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const role = Array.isArray(user.roles) ? user.roles[0]?.toLowerCase() : null;

    const routeMap = {
  salary: {
    admin: { name: "SalaryAdvanceReview" },
    employee: { name: "SalaryAdvanceRequest" },
    superadmin: { name: "SalaryAdvanceReview" },
    "material manager": { name: "SalaryAdvanceRequest" }
  },
  certificate: {
    admin: { name: "CertificateReview" },
    employee: { name: "CertificateRequest" },
    superadmin: { name: "CertificateReview" },
    "material manager": { name: "CertificateRequest" }
  },
  authorization: {
    admin: { name: "AuthorizationReview" },
    employee: { name: "AuthorizationRequest" },
    superadmin: { name: "AuthorizationReview" },
    "material manager": { name: "AuthorizationRequest" }
  }
};


      return routeMap[moduleName]?.[role] || { name: "Dashboard" };
    },
  },
};
</script>

<style scoped>
/* 🌈 Sidebar general */
#sidenav-collapse-main {
  background: transparent;
}

/* 🔗 Liens du sidebar */
.nav-link {
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  color: white;
  transition: background 0.3s ease, color 0.3s ease;
}

/* 👆 Hover effect */
.nav-link:hover {
  background-color: rgba(75, 85, 99, 0.4); /* gris clair */
  color: #ffffff;
}

/* 📂 Active nav-link (gris foncé) */
.nav-link.router-link-exact-active,
.nav-link.router-link-active {
  background-color: #4b5563 !important; /* gris foncé */
  color: #ffffff !important;
}

/* 🌟 Icônes */
.material-icons-round {
  vertical-align: middle;
  color: white;
  transition: color 0.3s ease;
}

/* 📑 Section title */
h6.text-xs {
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.7;
  padding: 8px 16px;
  margin-top: 12px;
}

/* 📂 Sub-menu */
.nav .nav-link {
  padding-left: 32px;
  font-size: 13px;
}

/* 🌟 Dropdown arrow */
.material-icons.fs-6 {
  font-size: 18px;
  transition: transform 0.3s ease;
}

/* ↕️ Open/close animation */
.nav-item > ul {
  transition: max-height 0.3s ease;
  overflow: hidden;
}

/* 🔽 Extra spacing between main nav items */
.navbar-nav > li {
  margin-bottom: 4px;
}

/* 🔽 Rotation arrow when open */
.nav-item.open .material-icons.fs-6 {
  transform: rotate(180deg);
}
</style>
